import React, { useEffect, useRef, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import {
    SeeProducts, SeeProductsByWinery} from '../../../actions/productActions'
import {
    seeWineries
} from '../../../actions/wineryActions'
import { Field, Form, Formik } from 'formik';
import Calendar from 'react-calendar';
import { Translate } from '../../../../language';
import inMemoryJWT from '../../../../auth/inMemoryJwt';
import ListItems from './WineryBatchesList/ListItems'
import Item from './WineryBatchesList/Item'
import { useTokenCallback } from '../../../../utils/hooks/useTokenCallback';
import useModal from '../../../../utils/hooks/useModal';
import { createBatch, deleteBatch, seeWineryBatches } from '../../../actions/wineryBatchesActions';
import { getReasonsForDeletion } from '../../../../actions/marketPlaceActions';
import style from './WineryBatches.module.css'
import TitleSVG from '../../../../utils/components/TitleSVG/TitleSVG';
import { BatchIcon } from '../../../../assets/icons';
import * as Yup from 'yup';
import Input from '../../../../utils/components/Input/Input';


const WineryBatches = ({ }) => {
    const dispatch = useDispatch()

    const [, setImgSrc] = useState("")
    const [wineryId, setWineryId] = useState("")
    const [isEidit, setIsEidit] = useState(false);
    const [batch, setBatch] = useState(null)
    const [, setProduct] = useState()
    const [skipBatchesList, setSkipBatchesList] = useState(0);


    const { productsList,  } = useSelector(state => state.productsList)
    const {  wineriesList } = useSelector(state => state.wineriesAdmin)
    const { wineryBatchesList, isLoadingWineryBatches, hasMoreWineryBatches } = useSelector(state => state.wineryBatchesAdmin)

    const [refExpe, isShowExpe, setIsShowExpe] = useModal(false)
    const [refExpy, isShowExpy, setIsShowExpy] = useModal(false)
    const [refDelete, isShowDelete, setIsShowDelete] = useModal(false)

    const formRef = useRef(null)
    const limitBatchesList = 10;


    const scrollPagination = (e) => {
        if (e.target.scrollTop + 1 >= (e.target.scrollHeight - e.target.clientHeight) && hasMoreWineryBatches) {
            setSkipBatchesList(skipBatchesList + limitBatchesList);
        }
    }

    useTokenCallback(() => {


    }, [])

    useEffect(() => {
        if (hasMoreWineryBatches) {
            dispatch(seeWineryBatches(limitBatchesList, skipBatchesList))
            dispatch(seeWineries())
            dispatch(SeeProducts())
        }
    }, [skipBatchesList]);


    useEffect(() => {
        if (!(inMemoryJWT.getToken())) {
            inMemoryJWT.getRefreshedToken()
        }

        inMemoryJWT.waitForTokenRefresh().then(() => {
            if (wineryId === "") {
                dispatch(SeeProducts())
            } else {
                dispatch(SeeProductsByWinery(wineryId))
            }

        })

    }, [wineryId])


    const validationSchema = Yup.object().shape({
        productId: Yup.string().required('Seleccione un producto'),
        code: Yup.string().required('Digite un código'),
        wineryId: Yup.string().required('Seleccione una bodega'),
        quantityProduced: Yup.number().positive("Cantidad no valida").required('Introduzca una cantidad'),
        expirationDate: Yup.string().required('Seleccione una fecha de expiración'),
        expeditionDate: Yup.string().required('Requerido'),
    });


    return (
        <div className={`${style.total_container}`}>
            <TitleSVG Icon={BatchIcon}
                titleHighlight={'L'}
                title={'otes'} />


            <div className={`${style.subtitle_container}`}>
                <div className={`${style.subtitle}`}>Formulario de creación de lotes</div>
            </div>


            <div className={`${style.record_grid_container}`}>


                <Formik
                    isInitialValid={false}
                    validationSchema={validationSchema}
                    onSubmit={(values) => {
                        dispatch(createBatch(values, formRef))
                    }}
                    onReset={() => {
                        setIsEidit(false);
                        setProduct(null);
                        setImgSrc("");
                    }}
                    initialValues={{
                        expeditionDate: new Date(),
                        expirationDate: "",
                        quantityProduced: '',
                        productId: "",
                        code: "",
                        wineryId: "",
                    }}

                    innerRef={formRef}>
                    {(props) => (
                        <Form className={`${style.form}`}>

                            <div className={`${style.create_grid} animate__animated animate__fadeIn`}>

                                <div className={`${style.record_grid_title}`}>
                                    Producto
                                </div>

                                <div className={`${style.record_grid_title}`}>
                                    Código
                                </div>

                                <div className={`${style.record_grid_title}`}>
                                    Ubicación
                                </div>

                                <div className={`${style.record_grid_title}`}>
                                    Cantidad producida
                                </div>

                                <div className={`${style.record_grid_title}`}>
                                    Fecha de expedición
                                </div>

                                <div className={`${style.record_grid_title}`}>
                                    Fecha de expiración
                                </div>

                                <div className={`${style.record_grid_title}`}>
                                </div>

                                <div>
                                    <Field
                                        className={`inputs-admin ${style.input_pointer}`}
                                        name="productId" as="select">
                                        <option value="">Seleccione</option>
                                        {
                                            productsList.map(product => (
                                                <option key={product._id} value={product._id}>{product.name}</option>
                                            ))
                                        }
                                    </Field>
                                    <div className={`${style.error}`}>{props.errors.productId}</div>
                                </div>

                                <div>
                                    <Field className='inputs-admin' type="text" name="code" />
                                    <div className={`${style.error}`}>{props.errors.code}</div>
                                </div>

                                <div>
                                    <Field
                                        className={`inputs-admin ${style.input_pointer}`}
                                        name="wineryId" as="select">
                                        <option value="">Seleccione</option>
                                        {
                                            wineriesList.map(winery => (
                                                <option key={winery._id} value={winery._id}>{winery.name}</option>
                                            ))
                                        }
                                    </Field>
                                    <div className={`${style.error}`}>{props.errors.wineryId}</div>
                                </div>

                                <div>
                                    <Field className='inputs-admin' type="number" name="quantityProduced" min={1} />
                                    <div className={`${style.error}`}>{props.errors.quantityProduced}</div>
                                </div>

                                <div>
                                    <input
                                        className={`inputs-admin ${style.input_pointer}`}
                                        readOnly
                                        type="text"
                                        value={props.values.expeditionDate.toLocaleDateString()}
                                        onClick={() => setIsShowExpe(true)}
                                    />
                                    {isShowExpe &&
                                        <div ref={refExpe} >
                                            <div

                                                style={{
                                                    display: isShowExpe ? 'block' : 'none'
                                                }}
                                                className="calendar-register" >
                                                <Calendar
                                                    maxDate={new Date()}
                                                    onChange={(dateTime) => {
                                                        props.setFieldValue('expeditionDate', new Date(dateTime));
                                                        setIsShowExpe(false)
                                                    }
                                                    }
                                                />
                                            </div>

                                        </div>
                                    }
                                </div>

                                <div>
                                    <input
                                        className={`inputs-admin ${style.input_pointer}`}
                                        id="date"
                                        readOnly
                                        name="date"
                                        type="text"
                                        value={props.values.expirationDate && props.values.expirationDate.toLocaleDateString()}
                                        onClick={() => setIsShowExpy(true)}
                                    />
                                    {isShowExpy &&
                                        <div ref={refExpy}>
                                            <div
                                                style={{
                                                    display: isShowExpy ? 'block' : 'none'
                                                }}
                                                className="calendar-register" >
                                                <Calendar
                                                    minDate={new Date()}
                                                    onChange={(dateTime) => {
                                                        props.setFieldValue('expirationDate', new Date(dateTime));
                                                        setIsShowExpy(false)
                                                    }
                                                    }
                                                />
                                            </div>
                                        </div>
                                    }
                                    <div className={`${style.error}`}>{props.errors.expirationDate}</div>
                                </div>

                                <div>
                                    <button type='submit'
                                        disabled={!props.isValid}
                                        className={`btns-admin btn-create-edit ${props.isValid ? style.button : 'btns-admin-inactive'}`}
                                    >{isEidit ? Translate('edit', 'es') : Translate('create', 'es')}</button>
                                </div>
                            </div>


                        </Form>
                    )}

                </Formik>
            </div>

            <div className={`${style.subtitle_container}`}>
                <div className={`${style.subtitle}`}>Listado de lotes</div>
            </div>
            <div>
                <div>
                    {(isLoadingWineryBatches && wineryBatchesList.length ===0) ? <div>Cargando...</div> :
                        <div className={style.record_grid_container}>

                            <div className={`${style.record_grid} animate__animated animate__fadeIn animate__delay-1s`} onScroll={scrollPagination}>

                                <div className={style.record_grid_title}>Producto</div>
                                <div className={style.record_grid_title}>Código</div>
                                <div className={style.record_grid_title}>Ubicación</div>
                                <div className={style.record_grid_title}>Cantidad producida</div>
                                <div className={style.record_grid_title}>Cantidad en stock</div>
                                <div className={style.record_grid_title}>Cantidad exportada</div>
                                <div className={style.record_grid_title}>Fecha de expedición</div>
                                <div className={style.record_grid_title}>Fecha de expiración</div>
                                <div className={style.record_grid_title}></div>

                                <ListItems>
                                    {wineryBatchesList.map((batch, index) => (
                                        <Item
                                            key={batch._id}
                                            product={batch.productId.name}
                                            code={batch.code}
                                            location={batch.wineryId.name}
                                            producedQuantity={batch.quantityProduced}
                                            stockQuantity={batch.quantityStock}
                                            exportedQuantity={batch.quantityExported}
                                            expirationDate={new Date(batch.expirationDate).toLocaleDateString()}
                                            expeditionDate={new Date(batch.expeditionDate).toLocaleDateString()}
                                            id={batch._id}
                                            onClickOption={() => {
                                                setBatch(batch)
                                                setIsShowDelete(true)
                                            }}
                                        />
                                    ))}
                                </ListItems>

                            </div>
                        </div>
                    }
                </div>
                <Modal
                    formRef={formRef}
                    batch={batch}
                    displayModal={isShowDelete}
                    closeModal={() => { setIsShowDelete(false) }}
                    style={style}
                />



            </div>
        </div >
    )
}

const Modal = ({ closeModal, displayModal, batch, formRef, style }) => {


    const [auxReasonForDeletionId, setAuxReasonForDeletionId] = useState(0);
    const dispatch = useDispatch();
    const { reasonsfordeletion } = useSelector(state => state.marketPlace)
    const divStyle = {
        display: displayModal ? 'block' : 'none'
    }

    const validationSchema = Yup.object().shape({
        reasonForDeletionId: Yup.string().required('Seleccione una razón'),
        quantityDeleted: Yup.number().positive("La cantidad no puede ser un valor negativo").required('Introduzca una cantidad'),
    });

    const clearValues = (formik) => {
        setAuxReasonForDeletionId('')
        formik.setFieldValue('reasonForDeletionId', '');
        formik.setFieldValue('quantityDeleted', '');
    }

    const close = (e) => {
        closeModal(e)
    }
    useEffect(() => {
        dispatch(getReasonsForDeletion())

        return () => {

        }
    }, [])
    const ref = useRef(null)
    if (!batch) {
        return <></>
    }

    return <div
        className={`${style.modal}`}
        style={divStyle}
        ref={ref}
        onClick={close}>
        <div
            className={`${style.modal_content}`}
            onClick={e => e.stopPropagation()} >
            <Formik
                isInitialValid={false}
                validationSchema={validationSchema}
                onSubmit={(values, actions) => {
                    ref.current.click()
                    dispatch(deleteBatch({
                        batchId: batch._id,
                        reasonForDeletionId: values.reasonForDeletionId,
                        quantityDeleted: values.quantityDeleted,
                        locationId: batch.wineryId._id
                    }));
                    setAuxReasonForDeletionId('');
                    actions.resetForm();
                }}
                initialValues={{
                    reasonForDeletionId: '',
                    quantityDeleted: 0
                }}>
                {(props) => (
                    <Form>
                        <div className={`${style.center}`}>

                            <div className={`${style.subtitle}`}>Seleccione la razón de eliminación</div>

                            <div>
                                {
                                    reasonsfordeletion.map(reason => (
                                        <div className={`${style.check_button_container}`} key={reason._id}>
                                            <input
                                                type="radio"
                                                name={"reasonForDeletion"}
                                                onChange={e => {
                                                    setAuxReasonForDeletionId(e.target.value);
                                                    props.setFieldValue('reasonForDeletionId', e.target.value);
                                                }}

                                                value={reason._id}
                                                checked={auxReasonForDeletionId ===reason._id}
                                            />
                                            {reason.name}
                                        </div>


                                    ))
                                }
                                <div className={`${style.error}`}>{props.errors.reasonForDeletionId}</div>

                            </div>
                        </div>


                        <div className={`${style.center} ${style.margin_top_10}`}>
                            <div className={`${style.subtitle}`}>
                                ¿Cuantos productos serán eliminados?
                            </div>
                            <Input
                                placeholder={"Cantidad a eliminar"}
                                type={"number"}
                                max={batch?.quantityStock}
                                min={1}
                                name={"quantityDeleted"}
                                value={props.values.quantityDeleted}
                                classNameInput={`${style.form_input} ${style.margin_top_10}`}
                                onChange={e => {
                                    props.setFieldValue('quantityDeleted', (parseInt(e.target.value, 10)))
                                }}
                            />
                            <div className={`${style.error}`}>{props.errors.quantityDeleted}</div>

                        </div>
                        <div className={`${style.center} content-buttom-create`}>
                            <button type='button'
                                onClick={
                                    (e) => {
                                        closeModal(e);
                                        props.resetForm();
                                        setAuxReasonForDeletionId('')
                                    }
                                }
                                className={`btns-admin btn-create-edit ${style.button}`}>{Translate('cancel', 'es')}
                            </button>
                            <button
                                type='submit'
                                disabled={!props.isValid}
                                className={`btns-admin btn-create-edit ${props.isValid ? style.button : 'btns-admin-inactive'}`}>{Translate('delete', 'es')}
                            </button>
                        </div>
                    </Form>)}

            </Formik>
        </div>
    </div>
}
export default WineryBatches